<div style="display: flex; height: 100%">
    <div
        class="wrapper"
        style="
            height: 100%;
            overflow: hidden;
            display: flex;
            flex-grow: 1;

            flex-direction: column;
        "
    >
        <div class="toolbar">
            <mat-toolbar class="main-toolbar">
                <a routerLink="/" [routerLinkActive]="'active'">
                    <div class="brand-logo-container">
                        <img src="assets/hero.png" alt="PDR Team" class="brand-logo" />
                    </div>
                </a>

                <span class="spacer"></span>
                <div *ngIf="authService.isAuthenticated()" class="navigation-buttons">
                    <button
                        mat-button
                        class="nav-button"
                        *ngFor="let item of navigation"
                        [routerLink]="[item.link]"
                        routerLinkActive="active"
                    >
                        <mat-icon *ngIf="item.icon">{{ item.icon }}</mat-icon>
                        <span class="nav-label">{{ item.label }}</span>
                    </button>
                </div>

                <div class="user-actions">
                    <button
                        *ngIf="!authService.isAuthenticated()"
                        (click)="loginWithMicrosoft()"
                        mat-raised-button
                        class="login-button"
                    >
                        <mat-icon>vpn_key</mat-icon>
                        <span>Login</span>
                    </button>

                    <button
                        *ngIf="authService.isAuthenticated()"
                        mat-button
                        class="user-menu-button"
                        [matMenuTriggerFor]="toolbarUserMenu"
                    >
                        <mat-icon>person</mat-icon>
                        <span class="user-name">{{ (authService.user | async)?.displayName }}</span>
                    </button>

                    <button
                        *ngIf="authService.isAuthenticated() && !showCallList"
                        mat-icon-button
                        class="call-button"
                        (click)="showCallList = !showCallList"
                    >
                        <mat-icon>call</mat-icon>
                    </button>
                </div>
                <mat-menu #toolbarUserMenu="matMenu">
                    <!--<button mat-menu-item routerLink="einstellungen">
            <mat-icon>settings</mat-icon>
            <span>Allgemeine Einstellungen</span>
          </button>-->
                    <button *ngIf="(firebaseService.admin | async)?.superAdmin" mat-menu-item routerLink="newsfeed">
                        <mat-icon>feed</mat-icon>
                        <span>News Feed</span>
                    </button>
                    <button *ngIf="(firebaseService.admin | async)?.superAdmin" mat-menu-item routerLink="checklists">
                        <mat-icon>playlist_add_check</mat-icon>
                        <span>Check Listen</span>
                    </button>
                    <button *ngIf="(firebaseService.admin | async)?.superAdmin" mat-menu-item routerLink="errorlogs">
                        <mat-icon>bug_report</mat-icon>
                        <span>Error Logs</span>
                    </button>
                    <button
                        *ngIf="
                            (firebaseService.admin | async)?.user_id === 'Udthq9t7i4YBlEX2K64ZQr3Oul22' ||
                            (firebaseService.admin | async)?.user_id === '0l7u6A6afVTgngfcK0k9Dllprxt2'
                        "
                        mat-menu-item
                        (click)="sanitizeData()"
                    >
                        <mat-icon>list</mat-icon>
                        <span>Datenpflege</span>
                    </button>
                    <button
                        *ngIf="
                            (firebaseService.admin | async)?.user_id === 'Udthq9t7i4YBlEX2K64ZQr3Oul22' ||
                            (firebaseService.admin | async)?.user_id === '0l7u6A6afVTgngfcK0k9Dllprxt2'
                        "
                        mat-menu-item
                        (click)="importAll()"
                    >
                        <mat-icon>list</mat-icon>
                        <span>Kundendaten sync</span>
                    </button>
                    <button
                        *ngIf="(firebaseService.admin | async)?.superAdmin"
                        mat-menu-item
                        (click)="askCreateAccount()"
                    >
                        <mat-icon>add_business</mat-icon>
                        <span>Kunden-Account anlegen</span>
                    </button>
                    <button
                        *ngIf="(firebaseService.admin | async)?.superAdmin"
                        mat-menu-item
                        (click)="openAccountCopy()"
                    >
                        <mat-icon>content_copy</mat-icon>
                        <span>Account Einstellungen kopieren</span>
                    </button>
                    <button *ngIf="(firebaseService.admin | async)?.superAdmin" mat-menu-item (click)="editTeamNews()">
                        <mat-icon>edit</mat-icon>
                        <span>Interne News</span>
                    </button>
                    <button *ngIf="(firebaseService.admin | async)?.superAdmin" mat-menu-item routerLink="/stats">
                        <mat-icon>leaderboard</mat-icon>
                        <span>Statistiken</span>
                    </button>
                    <button *ngIf="(firebaseService.admin | async)?.superAdmin" mat-menu-item routerLink="/offers">
                        <mat-icon>local_offer</mat-icon>
                        <span>Angebote</span>
                    </button>
                    <button
                        *ngIf="(firebaseService.admin | async)?.superAdmin"
                        mat-menu-item
                        routerLink="/offers/orders"
                    >
                        <mat-icon>shopping_cart</mat-icon>
                        <span>Bestellungen</span>
                    </button>
                    <button mat-menu-item (click)="onLogoutClick()">
                        <mat-icon>power_settings_new</mat-icon>
                        <span>Logout</span>
                    </button>
                </mat-menu>
            </mat-toolbar>
        </div>

        <div style="display: flex; flex-grow: 1; flex-direction: row; max-height: calc(100vh - 64px)">
            <div
                class="content"
                style="flex-grow: 1; display: flex; max-height: 100%"
                [@routerTransition]="o.isActivated && o.activatedRoute.routeConfig?.path"
            >
                <router-outlet #o="outlet"></router-outlet>
            </div>
        </div>
    </div>
    <div
        style="width: 300px; border-left: 2px solid black; display: flex; flex-direction: column"
        *ngIf="(firebaseService.admin | async)?.allowCalls && showCallList"
    >
        <mat-toolbar class="call-toolbar">
            <button mat-icon-button class="close-calls-button" (click)="showCallList = !showCallList">
                <mat-icon>phone</mat-icon>
            </button>
            <span class="call-title">Anrufe</span>
            <span class="spacer"></span>
        </mat-toolbar>
        <div style="flex-grow: 1; display: flex; max-height: calc(100vh - 60px)">
            <app-call-list></app-call-list>
        </div>
    </div>
</div>
